module.exports = __webpack_public_path__ + "static/media/HomeImage.fc5cfc3c.jpg";